import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
    state: {
        showNpsIframe: false,
    },
    mutations: {
        toShowNpsIframe(state) {
            state.showNpsIframe = true;
        },
        toHideNpsIframe(state) {
            state.showNpsIframe = false;
        },
    },
    actions: {},
};
